import apiClient from './api-client';

const authService = {
  login: async (credentials) => {
    try {
      const response = await apiClient.post('/auth/login', credentials);
      return response.data;
      
    } catch (error) {
        if(error.code === "ERR_NETWORK"){
          new Error('Erro de rede');
        }
      throw error.response ? error.response.data : new Error('Erro de rede');
    }
  },

  esqueciSenha: async (email) => {
    try {
      const response = await apiClient.post('/auth/esqueci-senha', {email});
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data?.message : new Error('Erro de rede');
    }
  },
  redefinirSenha: async (token, novaSenha) => {
    try {
      const response = await apiClient.post('/auth/redefinicao-senha', {token, novaSenha});
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data?.message : new Error('Erro de rede');
    }
  },
  validarTokenRedefinicaoSenha: async (token) => {
    try {
      const response = await apiClient.get('/auth/validar-token-redefinicao-senha', {params:{token}});
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data?.message : new Error('Erro de rede');
    }
  },
  logout: async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      throw new Error('Erro ao fazer logout');
    }
  },
};

export default authService;
